import IntlMessage from "../../helpers/intlMessage";
import React from "react";

export const tiposSolicitacoesEnum = {
  NOVO_CORTE: 0,
  APROFUNDAMENTO: 1
};

export const tiposSolicitacoesEnumList = [
  { value: tiposSolicitacoesEnum.NOVO_CORTE, label: <IntlMessage id='general.requestsPanel.newCut' /> },
  { value: tiposSolicitacoesEnum.APROFUNDAMENTO, label: <IntlMessage id='general.requestsPanel.deepening' /> }
];

export const statusSolicitacoesEnum = {
  SOLICITADO: 0,
  ANDAMENTO: 1,
  FEITO: 2
};

export const statusSolicitacoesEnumList = [
  { value: statusSolicitacoesEnum.SOLICITADO, label: <IntlMessage id='general.requestsPanel.requested' /> },
  { value: statusSolicitacoesEnum.ANDAMENTO, label: <IntlMessage id='general.requestsPanel.inProgress' /> },
  { value: statusSolicitacoesEnum.FEITO, label: <IntlMessage id='general.requestsPanel.done' /> }
];

export const filtroTipoEnum = {
  DATA_SOLICITACAO: 'dtSolicitacao',
  NR_EXAME: 'nrExame',
  TIPO: 'tipo',
  STATUS: 'status'
};

export const filtroTipoEnumList = [
  { label: <IntlMessage id='general.requestsPanel.requestDate' />, value: filtroTipoEnum.DATA_SOLICITACAO },
  { label: <IntlMessage id='general.requestsPanel.examNumber' />, value: filtroTipoEnum.NR_EXAME },
  { label: <IntlMessage id='general.requestsPanel.type' />, value: filtroTipoEnum.TIPO },
  { label: <IntlMessage id='general.requestsPanel.status' />, value: filtroTipoEnum.STATUS }
];

export const returnParamiters = ({
  periodoInicial,
  periodoFinal,
  tipo,
  value
}) => {
  switch (tipo) {
    case filtroTipoEnum.DATA_SOLICITACAO:
      return {
        dataInicio: periodoInicial,
        dataFim: periodoFinal
      };
    case filtroTipoEnum.NR_EXAME:
      return { nrExame: value ? value : '' };
    case filtroTipoEnum.TIPO:
      return { tipo: value };
    case filtroTipoEnum.STATUS:
      return { status: value };
    default:
      return {};
  }
};



// WEBPACK FOOTER //
// ./src/pages/solicitacao/solicitacao.utils.js